var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("content-creator", {
    attrs: {
      settings: _vm.blobContents,
      permissions: _vm.contentCreatorPermissions,
      "is-visible": _vm.editContentCreator,
      name: _vm.blobName,
      filestore: _vm.websitefilestore,
      "allowed-widgets":
        "grid, link-list, advanced-wysiwyg-editor, wysiwyg-editor, carousel, content-list, content-grid, vimeo-video",
    },
    on: { updateBlob: _vm.savePageContentBlob },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }